import { NgModule } from '@angular/core';
import { CheckpointsPerUnitTableComponent } from './checkpoints-per-unit-table/checkpoints-per-unit-table.component';
import { CommonModule } from '@angular/common';
import { UtilitiesModule } from '../../utilities/utilities.module';
import { CellViewComponent } from './checkpoints-per-unit-table/cell-view/cell-view.component';
import { TextPlainComponent } from './checkpoints-per-unit-table/cell-view/text-plain/text-plain.component';
import { EmptyComponent } from './checkpoints-per-unit-table/cell-view/empty/empty.component';
import { TextComponent } from './checkpoints-per-unit-table/cell-view/text/text.component';
import { ArrayComponent } from './checkpoints-per-unit-table/cell-view/array/array.component';
import { ChecklistReportViewPieChartComponent } from './checklist-report-view-pie-chart/checklist-report-view-pie-chart.component';
import { FiSwipeModule } from '@fi-shared/fi-directives/fi-swipe/fi-swipe.module';
import { ChecklistReportOverTimeUnitsComponent } from './checklist-report-over-time-units/checklist-report-over-time-units.component';
import { ChecklistReportCheckpointsPerUnitComponent } from './checklist-report-checkpoints-per-unit/checklist-report-checkpoints-per-unit.component';
import { ChecklistReportCheckpointsOnUnitComponent } from './checklist-report-checkpoints-on-unit/checklist-report-checkpoints-on-unit.component';
import { ChecklistReportDetailsComponent } from './checklist-report-details/checklist-report-details.component';
import { ChecklistReportSelectionComponent } from './checklist-report-selection/checklist-report-selection.component';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ChecklistReportSelectionDialogComponent } from './checklist-report-selection-dialog/checklist-report-selection-dialog.component';
import { ChecklistReportViewComponent } from '../checklist-report-view.component';
import { ChecklistReportSelectReportDialogComponent } from './checklist-report-select-report-dialog/checklist-report-select-report-dialog.component';
import { FiChecklistReportSaveFilterDialogComponent } from './checklist-report-save-filter-dialog/checklist-report-save-filter-dialog.component';
import { ComponentsModule } from '@fi-app/components/components.module';
import { FiPrintDownloadModule } from '@fi-shared/fi-print-download/fi-print-download.module';
import { FiMediaBankFileReferencePreviewModule } from '@fi-shared/fi-media-bank-file-reference-preview/fi-media-bank-file-reference-preview.module';
import { FiAttachmentsModule } from '@fi-shared/media-bank/fi-attachments/fi-attachments.module';
import { SelectSearchModule } from '@fi-shared/fi-select-search/select-search.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        UtilitiesModule,
        ComponentsModule,
        FiSwipeModule,
        FiMediaBankFileReferencePreviewModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatDialogModule,
        FiPrintDownloadModule,
        FiAttachmentsModule,
        SelectSearchModule,
    ],
    declarations: [
        CheckpointsPerUnitTableComponent,
        CellViewComponent,
        TextPlainComponent,
        EmptyComponent,
        TextComponent,
        ArrayComponent,
        ChecklistReportViewPieChartComponent,
        ChecklistReportOverTimeUnitsComponent,
        ChecklistReportCheckpointsPerUnitComponent,
        ChecklistReportCheckpointsOnUnitComponent,
        ChecklistReportDetailsComponent,
        ChecklistReportSelectionComponent,
        ChecklistReportSelectionDialogComponent,
        ChecklistReportViewComponent,
        ChecklistReportSelectReportDialogComponent,
        FiChecklistReportSaveFilterDialogComponent,
    ],
})
export class ChecklistReportViewModule {}
